import Api from '@/apis/photos-api';
import Vue from 'vue';
// content: album -> categories, category -> galleries
// activeId is the id of the activ category or gallery
const album = {
  state: {
    // for images
    baseURL: 'http://www.michelepauty.com/galleries',
    // baseURL: 'http://api.uther.com/album',
    albumId: 1,
    categoryId: null,
    galleryId: null,
    photoId: null,
    view: '',
    content: '',
    albums: {},
    categories: {},
    galleries: {},
    photos: {},
    favourites: null,
    activeId: '',
    activePhotoId: '',
    activePhotoIndex: '',
    sortByValue: 'sorted',
    sortedData: [],
    coverId: ''
  },
  getters: {
    baseURL(state) {
      return state.baseURL;
    },
    view(state) {
      return state.view;
    },
    content(state) {
      return state.content;
    },
    albums(state) {
      return state.albums[state.albumId];
    },
    categories(state) {
      return state.categories[state.albumId];
    },
    galleries(state) {
      return state.galleries[state.categoryId];
    },
    photos(state) {
      return state.photos[state.activeId];
    },
    favourites(state) {
      return state.favourites;
    },
    activeId(state) {
      return state.activeId;
    },
    activePhotoId(state) {
      return state.activePhotoId;
    },
    activePhotoIndex(state) {
      return state.activePhotoIndex;
    },
    sortByValue(state) {
      return state.sortByValue;
    },
    sortedData(state) {
      return state.sortedData;
    },
    coverId(state) {
      return state.coverId;
    }
  },
  actions: {
    loadContent({ commit }, payload) {
      const { apiPath, content } = payload;
      return Api.get(apiPath).then((response) => {
        commit(content, response.data);
      }).catch((error) => {
        console.log('error', error);
      });
    },
    createFolder({ commit, state }, payload) {
      const { apiPath, title, description } = payload;
      return Api.createFolder(apiPath, title, description).then((response) => {
        const { data } = response.data;
        commit('addItem', data);
      }).catch((error) => {
        console.log(error);
      });
    },
    reorder({ commit }, payload) {
      const { content, sorts } = payload;
      return Api.reorder(content, sorts).then(() => {
        commit('reorder', { content, sorts });
      }).catch((error) => {
        console.log(error);
      });
    },
    // update properties
    update({ commit }, payload) {
      const { props, apiPath, target, parentId, targetId } = payload;
      return Api.update(apiPath, props).then((response) => {
        commit('update', { props, target, parentId, targetId });
      }).catch((error) => {
        console.log(error);
      });
    },
    // update properties
    delete({ commit }, payload) {
      const { apiPath, targetId } = payload;
      return Api.delete(apiPath).then((response) => {
        commit('delete', targetId);
      }).catch((error) => {
        console.log(error);
      });
    },
    // upload photos
    upload({ commit }, payload) {
      const { formData, id, config } = payload;
      return Api.upload(formData, id, config).then((response) => {
        const { data } = response.data;
        console.log(data);
        commit('addItem', data);
      }).catch((error) => {
        console.log(error);
      });
    }
  },
  mutations: {
    delete(state, targetId) {
      const items = state[state.content][state.activeId];
      const index = items.findIndex(item => {
        return item.id.toString() === targetId.toString();
      });
      items.splice(index, 1);
    },
    view(state, view) {
      state.view = view;
    },
    content(state, content) {
      state.content = content;
    },
    albumId(state, id) {
      state.albumId = id;
    },
    categoryId(state, id) {
      state.categoryId = id;
    },
    galleryId(state, id) {
      state.galleryId = id;
    },
    activeId(state, id) {
      state.activeId = id;
    },
    activePhotoId(state, id) {
      state.activePhotoId = id;
    },
    coverId(state, id) {
      state.coverId = id;
    },
    activePhotoIndex(state, id) {
      state.activePhotoIndex = id;
    },
    addItem(state, data) {
      // add content
      state[state.content][state.activeId].unshift(data);
      // set content -> invoke deep update
      Vue.set(state[state.content], state.activeId, state[state.content][state.activeId]);
    },
    // insert data
    albums(state, data) {
      Vue.set(state.albums, state.activeId, data);
    },
    categories(state, data) {
      Vue.set(state.categories, state.albumId, data);
    },
    galleries(state, data) {
      Vue.set(state.galleries, state.categoryId, data);
    },
    photos(state, data) {
      Vue.set(state.photos, state.galleryId, data);
    },
    favourites(state, data) {
      state.favourites = data;
    },
    // update values
    reorder(state, payload) {
      const { content, sorts } = payload;
      sorts.forEach((item, index) => {
        const obj = state[content][state.activeId].find(obj => { return obj.id === sorts[index].id; }); // eslint-disable-line
        obj.sort = sorts[index].sort;
      });
    },
    sortByValue(state, { value }) {
      state.sortByValue = value;
    },
    sortedData(state, { data }) {
      state.sortedData = data;
    },
    // props: {prop: value, prop: value}
    update(state, payload) {
      const { props, target, parentId, targetId } = payload;
      const data = state[target][parentId].find(item => {
        return item.id.toString() === targetId.toString();
      });
      for (var key in props) {
        Vue.set(data, key, props[key]);
      }
    }
  }
};

export default album;



// WEBPACK FOOTER //
// ./src/store/album/index.js